import React from 'react';
import commonResource from '../../locales/th/common.json';
import { MostPopular } from '../../queries/homePage/mostPopular';
import MostPopularCard from './MostPopularCard';
import {
  MostPopularPostsTitleWrapper,
  MostPopularPostsWrapper,
} from './MostPopularPosts.style';

interface MostPopularPostsProps {
  post: MostPopular[];
  onClick?: (post: MostPopular) => void;
}

const MostPopularPosts: React.FC<MostPopularPostsProps> = ({
  post,
  onClick,
}) => {
  if (!post?.length) {
    return null;
  }

  return (
    <MostPopularPostsWrapper data-test="most-popular">
      <MostPopularPostsTitleWrapper>
        {commonResource.mostPopularTitle}
      </MostPopularPostsTitleWrapper>
      <div>
        {post.map((item) => (
          <MostPopularCard
            post={item}
            key={item.id}
            onClick={(post) => onClick(post)}
          />
        ))}
      </div>
    </MostPopularPostsWrapper>
  );
};

export default MostPopularPosts;
